/**
 * 받은 파일을 저장한다 — **한 곳에서만** 한다.
 *
 * ★ 객체 URL 은 **반드시 되돌려 준다**(`revokeObjectURL`). 안 그러면 그 탭이 살아 있는 동안
 *   블롭이 메모리에 남는다 — 큰 파일을 여러 번 받으면 눈에 띈다.
 * ★ `<a>` 를 문서에 붙였다가 떼는 것은 파이어폭스 때문이다(붙지 않은 앵커는 클릭이 안 먹는다).
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
